import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import ApplicationApiCallBackActions from '../actions/ApplicationApiCallBackActions.js';
import ErrorHandler from '../core/ErrorHandler.js';

module.exports = {
    downloadForms: function(selectedForms, productId, formModel) {
        let url = APIUrl.DOWNLOAD_FORMS_URL.replace('{pid}', productId).replace('{fid}', selectedForms);
        const data = JSON.stringify(formModel);
        axios.post(url, data)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                ApplicationApiCallBackActions.downloadFormsSuccess(response.data);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.downloadFormsFailed();
                ErrorHandler.logError(Error('download forms', error));
            });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/DownloadsAPI.js